<script>
export default {
  props: {
    onParameterAlertClick: {
      type: Function,
      required: true,
    },
  },
}
</script>
